import { render, staticRenderFns } from "./CsvTable.vue?vue&type=template&id=70794d6a&scoped=true&"
import script from "./CsvTable.vue?vue&type=script&lang=ts&"
export * from "./CsvTable.vue?vue&type=script&lang=ts&"
import style0 from "./CsvTable.vue?vue&type=style&index=0&id=70794d6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70794d6a",
  null
  
)

export default component.exports